import { ISelectItem } from "@/types";
import { IStatus, IStatusRequest } from "@/types/status";

export class Status implements IStatus {
  public id = 0;
  public name = "";
  public color = "";

  public constructor(props?: IStatus) {
    if (!props) {
      return;
    }
    Object.assign(this, props);
  }

  public static toSelectItem(member: IStatus): ISelectItem {
    return {
      text: member.name,
      value: member.id,
    };
  }
}

export class StatusRequest implements IStatusRequest {
  public id = 0;
  public name = "";
  public color = "";

  public constructor(props?: IStatus) {
    if (!props) {
      return;
    }
    Object.assign(this, props);
  }
}
